<template>
  <div class="control-panel">
    <row class="panel-title">
      <column>
        <h4 class="dark">
          Control Panel
        </h4>
      </column>
      <suffix>
        <button class="btn-icon gravel-to-blue collapse-toolbox" @click="panelCollapse()" type="button">
          <span class="sr-only">Collapse/Reveal Toolbox</span>
          <span class="icon arrow-double"></span>
        </button>
      </suffix>
    </row>

    <scroll-area class="panel">
      <control-group group-name="Relationship Types" list-style>
        <li v-for="item in control_groups">
          <button data-c-tooltip-class="control-panel-tooltip right"
                  :data-c-tooltip="item.name"
                  :aria-label="item.name"
                  :data-type="item.type"
                  :class="controlClasses"
                  @mousedown.left="drag">
            <icon :class="item.icon"></icon>
            {{ item.name }}
          </button>
        </li>
      </control-group>
    </scroll-area>

    <create-relationship-modal
      v-if="modalStateFor(vueModalID.createObjectModelRelationship).isVisible"
      :index="vueModalID.createObjectModelRelationship"
      :object-model="{reference_name: objectModel.reference_name}"
      :reference-names-taken="referenceNames"
      :relation-type="dropData.relationType"
      :state="modalStateFor(vueModalID.createObjectModelRelationship)"
      @create="createRelation"
      @toggle-modal="hideModal(vueModalID.createObjectModelRelationship)"
    />
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {Hash} from "../../../common/interfaces/hashInterfaces";
  import ObjectModelRelationDefinition from "../../../common/models/objectModelRelations/objectModelRelationDefinition";
  import ObjectModel from "../../../common/models/objectModel";
  import configPanelDragMixin from "../../../common/mixins/drag/controlPanelDragMixin"
  import storeMapper from "../../../common/mixins/storeMappers/storeMapper";
  import {BuilderArea} from "../enums/builder-area";
  import CreateRelationshipModal from '@/formability/object_model_builder/components/create-relationship-modal.vue'
  import modalController from '~/mixins/modalController'

  const objectModelStoreMixin = storeMapper('objectModelStore', {state: ['objectModel']});

  export default Vue.extend({
    components: {
      CreateRelationshipModal,
    },
    mixins: [
      configPanelDragMixin,
      objectModelStoreMixin,
      modalController,
    ],
    data: function () {
      return {
        control_groups: ObjectModelRelationDefinition.getControlGroups(),
        draggableClasses: ['om-relation-draggable'],
        droppableClasses: ['object-model-relation'],
        dragArea: BuilderArea.relationships,
        onDrop: data => {
          this.dropData = data
          this.isSaving = false
          this.showModal(this.vueModalID.createObjectModelRelationship)
        },
        isSaving: false,
        dropData: {},
      };
    },
    computed: {
      controlClasses(): Hash<boolean> {
        return {
          'om-relation-draggable': true,
        };
      },
      targetRoot(): ObjectModel {
        return this.objectModel;
      },
      referenceNames(): string[] {
        return this.objectModel.objectModelRelationsArray.map(omr => omr.reference_name)
      },
    },
    methods: {
      createRelation(createData) {
        this.isSaving = true
        this.targetRoot.appendRelation(this.dropData.relationType, this.dropData.position, createData)
        this.hideModal(this.vueModalID.createObjectModelRelationship)
      },
    },
  });
</script>